/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import { pathTranslate } from '@/helpers/routeHelpers'
import Config from '@/config'

export default {
  language (state) {
    return state.locale ? state.locale.split('_')[0] : ''
  },
  getCurrentLang (state, a, b, rootGetters) {
    if (state.currentCountry) {
      return state.currentCountry.country + ' - ' + rootGetters['storeConfig/language']
    } else {
      return ''
    }
  },
  menu (state) {
    return state.menu.map(item => ({
      ...item,
      url: item.url.replace('_lang_', state.storeViewCode).replace('contact-us', pathTranslate({ path: 'contact-us' }))
    }))
  },
  countryCode: state => state.currentCountry ? state.currentCountry.country : '',
  getCountries (state) {
    return state.countries
  },
  getActiveCountry (state) {
    let country = Config.Theme.defaultCountry[state.sizeCountrySelected] === undefined ? Config.Theme.sizeCountries[1].value : Config.Theme.defaultCountry[state.sizeCountrySelected]
    return country
  },
  getListingColumns (state) {
    return {
      columns: state.listingColumns,
      calculated: (12 / state.listingColumns)
    }
  },
  isMobile (state) {
    return state.isMobile
  }
}
